/* Leaf Lab collection grid: plain wrapped row on desktop, touch-swipeable
   carousel below 750px. Mirrors the ResizeObserver init/destroy pattern used
   by multicolumn.js -- Swiper is only ever instantiated under the mobile
   breakpoint, since this section has no desktop-slider option. */
(function () {
  const initSlider = (section) => {
    const slider = section.querySelector(".leaflab-collection-info__slider");
    if (!slider) return;

    const slides = slider.querySelectorAll(".leaflab-collection-info__cell");
    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    new Swiper(slider, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 600,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true,
      },
    });
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".leaflab-collection-info__slider");
    const slides = section.querySelectorAll(".leaflab-collection-info__cell");

    if (slider?.swiper) slider.swiper.destroy();

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });
  };

  const initLeaflabCollectionInfo = (section) => {
    if (!section) return;

    const slider = section.querySelector(".leaflab-collection-info__slider");
    if (!slider) return;

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 750) {
          initSlider(section);
        } else {
          destroySlider(section);
        }
      });
    });

    resizeObserver.observe(section);
  };

  initLeaflabCollectionInfo(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initLeaflabCollectionInfo(event.target);
  });
})();
